module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page2"
  }, [_c('div', {
    staticClass: "vip-introduce"
  }, [_vm._l((_vm.introData), function(item, i) {
    return (i === _vm.currentIndex) ? _c('div', {
      key: i,
      staticClass: "swiper-page"
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', [(i === _vm.currentIndex) ? _c('div', {
      staticClass: "intro-left"
    }, [_c('p', {
      staticClass: "intro-title"
    }, [_vm._v("\n                                " + _vm._s(item.introTitle) + "\n                                "), _c('i', {
      staticClass: "under-line"
    })]), _vm._v(" "), _c('div', {
      staticClass: "intro-desc"
    }, [_vm._l((item.introDesc), function(content) {
      return _c('p', {
        staticClass: "desc-content"
      }, [_c('i', {
        staticClass: "desc-icon"
      }), _vm._v(" "), _c('span', {
        staticClass: "desc-text"
      }, [_vm._v(_vm._s(content))])])
    }), _vm._v(" "), _c('div', {
      staticClass: "btn-buyvip",
      on: {
        "click": function($event) {
          return _vm.showDialog(item.actionType)
        }
      }
    }, [_c('p', {
      staticClass: "btn-text"
    }, [_vm._v(_vm._s(item.introBtnText))])])], 2)]) : _vm._e(), _vm._v(" "), (i === _vm.currentIndex) ? _c('div', {
      staticClass: "intro-right"
    }, [_c('img', {
      staticClass: "intro-demoimmg",
      attrs: {
        "src": item.introDemoImg,
        "alt": ""
      }
    })]) : _vm._e()])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "vip-intro-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }, [_c('div', {
    staticClass: "intro-nav"
  }, [_c('ul', _vm._l((_vm.introData), function(item, i) {
    return _c('li', {
      staticClass: "custom-index",
      on: {
        "click": function($event) {
          return _vm.changeIndex(i, item.tabActionType)
        }
      }
    }, [_c('i', {
      staticClass: "active-bg",
      class: {
        'active': i === _vm.currentIndex
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "custom-text",
      class: {
        'active-text': i === _vm.currentIndex
      }
    }, [_vm._v(_vm._s(item.introTitle))])])
  }), 0)])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71578f03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/vipIntroduce/VipIntroduce.vue
// module id = tOvU
// module chunks = 1